import React, { Component, PropTypes } from 'react';
import partial from 'lodash/partial';
import { CheckBoxField, TextAreaField } from 'common/components/form_fields';
import ImageUpload from 'common/components/image_upload';
import AnimatedButton from 'common/components/animated_button';

/**
 * Image work samples upload.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
class ImageSamplesUpload extends Component {

  constructor(props) {
    super(props);

    const { samples, group } = props;
    const groupSamples = samples[group.id] || {};

    this.state = {
      /* copy samples to internal state so that the ones in the store
         are only updated if the changes are successfully uploaded to the server */
      samples: groupSamples,
      viewing: !!groupSamples['sample_1'],
      selected: 1,
      agreed: false
    };

    this.update = this.update.bind(this)
    this.select = this.select.bind(this)
    this.remove = this.remove.bind(this)
    this.upload = this.upload.bind(this)
  }

  update(pic, i) {
    const { selected, samples } = this.state
    const idx = i || selected
    let newState = {
      samples: {...samples, [`sample_${idx}`]: pic}
    }

    /* if removing selected picture, leave viewing mode */
    if (selected == i && !pic) {
      newState['viewing'] = false
    }

    this.setState(newState)
  }

  select(i, empty, active) {
    /* ignore if already selected */
    if (active) return

    /* if selected image is not empty, toggle viewing mode by default */
    this.setState({selected: i, viewing: !empty})
  }

  remove(e, i) {
    e.stopPropagation()
    this.update(null, i)
  }

  upload() {
    const { samples } = this.state;
    const { group, onDone, upload } = this.props;
    upload(group, samples, onDone);
  }

  render() {
    const { group, uploading, error, onDone } = this.props;
    const { samples, selected, viewing, agreed } = this.state;
    const selectedPic = samples[`sample_${selected}`];
    const btnDisabled = (
      !agreed || Object.keys(samples).length != 3 || Object.values(samples).some((s) => !s)
    );

    return (
      <div className="image-samples-upload">
        <div className="row">
          <div className="columns small-16 medium-6 hide-for-small-only left-side">
            <h3>Requirements</h3>
            <ul>
              <li>Must be your original work</li>
              { group.name === "Logo & Identity" &&
              <li>No stock or clip art</li> }
              <li>JPG or PNG only</li>
              <li>Use RGB colorspace</li>
              <li>Square images are best</li>
              <li>800 x 800 min size</li>
              <li>20MB max file size</li>
            </ul>

            { group.name === "Packaging Design" &&
            <div className="packaging-design-notice">
              <h4>IMPORTANT:</h4>
              This category is only for the design of actual product packaging. THIS IS NOT
              FOR THE GRAPHICS THAT GO ON PACKAGING. If you know how to design bottles, boxes,
              and other containers, submit examples of your 3 dimensional designs here. Otherwise,
              if you design only graphics or labels, submit your work samples in the Graphic
              Design category.

              <h5>EXAMPLES OF PACKAGING DESIGN:</h5>

              <div className="text-center">
                <img src="https://crowdspring3-assets.s3.amazonaws.com/marketing/cup-for-italy_package-design_crowdspring.jpg"/>
               <img src="https://crowdspring3-assets.s3.amazonaws.com/marketing/bottle-design.jpg"/>
              </div>
             </div> }
          </div>

          <div className="columns small-16 medium-10 right-side">
            { viewing?
            <img className="preview" src={selectedPic}/> :
            <div className="form-upload-box">
              <ImageUpload minWidth={15} minHeight={15} onCrop={this.update} selectImage={this.update}
                preCrop={selectedPic} onDone={() => this.setState({viewing: true})} />
            </div> }
            <div className="items">
              {[1, 2, 3].map((i) => {
                const active = selected == i
                const pic = samples[`sample_${i}`] || ''
                return (
                  <div key={i} className={"item" + (active? " active":"")}
                       onClick={partial(this.select, i, !pic, active)}>
                    {pic &&
                    <i className="fa fa-times-circle remove" onClick={(e) => this.remove(e, i)}></i>}
                    <div className="pic-num">{i}</div>
                    <img src={pic} className="preview-pic"/>

                  </div>)
              }) }
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <CheckBoxField meta={{}} label="I have read and agree to these requirements"
            input={{
              value: agreed,
              name: 'agreed',
              onChange: (v) => this.setState({ agreed: v })
            }} />

          <AnimatedButton processing={uploading} label="Upload" processingLabel="Uploading..."
            errorMsg={error} successMsg="Done!" onClick={this.upload}
            disabled={btnDisabled} baseBtnClass="btn-tertiary btn-block"/>
          <button className="btn btn-text btn-block" onClick={onDone}>Cancel</button>
        </div>

      </div>
    );
  }
}

ImageSamplesUpload.propTypes = {
  samples: PropTypes.object,
  group: PropTypes.object.isRequired,
  uploading: PropTypes.bool,
  error: PropTypes.string,
  upload: PropTypes.func.isRequired,
  onDone: PropTypes.func
};

export default ImageSamplesUpload;



// WEBPACK FOOTER //
// ./registration/creative/components/image_samples_upload.jsx